module.exports = __webpack_public_path__ + "assets/a3fc2e3850f7fabae65082d82c9f703a.mp3";